import { TranslationMap } from '@trimble-gcs/i18n-types';

export function classificationEditTranslations() {
  return {
    title: {
      add: {
        text: $localize`:@@classificationEdit.title.add:Add Classification`,
        desc: 'Title for the classification add panel when adding a new classification.',
      },
      edit: {
        text: $localize`:@@classificationEdit.title.edit:Edit Classification`,
        desc: 'Title for the classification edit panel when editing an existing classification.',
      },
    },
    close: {
      tooltip: {
        text: $localize`:@@classificationEdit.close.tooltip:Close`,
        desc: 'Tooltip for the top right "X" button that closes the classification add/edit panel.',
      },
    },
    notice: {
      text: $localize`:@@classificationEdit.notice:Note: This action applies to all classifications for the project.`,
      desc: 'Notice displayed at the top of the classification add/edit panel.',
    },
    input: {
      number: {
        text: $localize`:@@classificationEdit.input.number:Class #`,
        desc: 'Label for the classification number field.',
      },
      name: {
        text: $localize`:@@classificationEdit.input.name:Description`,
        desc: 'Label for the classification name input field.',
      },
      color: {
        text: $localize`:@@classificationEdit.input.color:Point Style`,
        desc: 'Label for the classification color picker.',
      },
      visibility: {
        text: $localize`:@@classificationEdit.input.visibility:Default 3D Visibility`,
        desc:
          'Label for the classification visibility switch/toggle which sets the default visibilty ' +
          'when viewing model classifications in 3D.',
      },
      visibilityOn: {
        text: $localize`:@@classificationEdit.input.visibilityOn:Visible`,
        desc: 'Label for the classification visibility switch/toggle when set to visible.',
      },
      visibilityOff: {
        text: $localize`:@@classificationEdit.input.visibilityOff:Hidden`,
        desc: 'Label for the classification visibility switch/toggle when set to hidden.',
      },
    },
    error: {
      text: $localize`:@@classificationEdit.error:There was an error saving the classification template.`,
      desc: 'Error message displayed when there was an error saving the classification changes.',
    },
    cancel: {
      text: $localize`:@@classificationEdit.cancel:Cancel`,
      desc: 'Button text to discard changes and close the classification add/edit panel.',
    },
    save: {
      text: $localize`:@@classificationEdit.save:Save`,
      desc: 'Button text to save the classification changes and close the classification add/edit panel.',
    },
  } satisfies TranslationMap;
}
